// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import clockSvgSrc from './clock-regular.svg';
import { Separator } from '../../../../atoms';

export function BoletoTip(): Node {
  return (
    <BoletoTipRoot>
      <BoletoTipIcon />
      <Separator direction="horizontal" size={4} />
      <BoletoTipMessage />
    </BoletoTipRoot>
  );
}

const BoletoTipRoot = styled.div`
  display: flex;
  color: ${props => props.theme.colors.neutral[900]};
  background-color: ${props => props.theme.colors.new_primary[50]};
  padding: 20px 20px;
`;

function BoletoTipIcon(): Node {
  return (
    <BoletoTipIconRoot>
      <BoletoTipIconBackground>
        <BoletoTipIconImage src={clockSvgSrc} alt="clock icon" />
      </BoletoTipIconBackground>
    </BoletoTipIconRoot>
  );
}

const BoletoTipIconRoot = styled.div``;

const BoletoTipIconBackground = styled.div`
  width: 24px;
  height: 24px;
  background: ${props => props.theme.colors.new_primary[600]};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
`;

const BoletoTipIconImage = styled.img`
  height: 16px;
  fill: white;
  width: 100%;
`;

function BoletoTipMessage(): Node {
  return (
    <BoletoTipMessageRoot>
      <BoletoTipMessageContent>
        Dica: Pagar seu boleto até às <strong>21h</strong> de dias úteis faz com que o pagamento seja confirmado mais rápido :)
      </BoletoTipMessageContent>
    </BoletoTipMessageRoot>
  );
}

const BoletoTipMessageRoot = styled.div`
  flex-grow: 1;
`;

const BoletoTipMessageContent = styled.p`
  text-align: left;
  font-size: 0.85em;
`;
